module.exports = __webpack_public_path__ + "img/guide-ja-4.5aed0055.png";